import InnerComponent from '@Components/Integrations/TallyIntegration';
import orgContainer from '@Components/AppContainer';

const TallyIntegration = () => ((orgContainer(InnerComponent)));
export default TallyIntegration;
